import Cookies from 'js-cookie';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';


const isProd = import.meta.env.PROD;
const pusherAppKey = import.meta.env.VITE_PUSHER_APP_KEY;


Pusher.logToConsole = false;
window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: pusherAppKey,
    cluster: 'us3',
    forceTLS: true,
    auth: {
        headers: {
            Authorization: `Bearer ${Cookies.get('token')}`,
            Accept: 'application/json',
        }
    },
    authEndpoint: '/broadcasting/auth',
    ...(isProd && {
        authHost: 'https://tenant.fleetwire.io',
    }),
});